// material-ui
import {} from '@mui/material'

// assets

import CustomerSettingsComponent from 'components/CustomerSettingsComponent'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function main(): any {
    return <CustomerSettingsComponent />
  }

  let output_main = main()

  return output_main
}
